import React from 'react';
import { Form } from 'react-bootstrap';

import AutocompleteField from '@components/Form/AutocompleteField';
import TextField from '@components/Form/TextField';
import FirstPartyDataFields from '@components/UserOnboardingModal/ProfileFields/FirstPartyDataFields';
import { useEntitiesCreate } from '@hooks';
import { autocompleteEntities } from '@utils/backend-api/entities';
import { ENTITY_TYPE_JOB_TITLE } from '@utils/backend-api/profileSettings';
import checkForExistenceInArray from '@utils/checkForExistenceInArray';

interface NUXFormProps {
  dataFields?: string[];
  optionalFirstPartyFields?: string[];
  silenceToast?: boolean;
}

const NUXForm = ({
  dataFields,
  optionalFirstPartyFields,
  silenceToast,
}: NUXFormProps): JSX.Element => {
  const { mutateAsync: createEntityAsync } = useEntitiesCreate(silenceToast);

  const includesTitleAtCompany = checkForExistenceInArray({
    arrayData: dataFields,
    phrase: 'titleAtCompany',
  });

  return (
    <Form className="form-container">
      {checkForExistenceInArray({ arrayData: dataFields, phrase: 'name' }) && (
        <div className="mb-8 flex gap-4">
          <TextField name="firstName" label="First Name&#42;" className="w-1/2" />
          <TextField name="lastName" label="Last Name&#42;" className="w-1/2" />
        </div>
      )}
      {includesTitleAtCompany && (
        <div className="mt-24">
          <AutocompleteField
            label={`Job Title${includesTitleAtCompany ? '*' : ''}`}
            name="jobTitle"
            fetchMethod={(value) =>
              autocompleteEntities({
                fragment: value,
                entity_type: ENTITY_TYPE_JOB_TITLE,
              })
            }
            createMethod={(value) =>
              createEntityAsync({
                name: value,
                entity_type: ENTITY_TYPE_JOB_TITLE,
                word_type: 'proper',
              })
            }
            placeholder="Type to search titles…"
          />
        </div>
      )}
      <FirstPartyDataFields
        dataFields={dataFields}
        optionalFirstPartyFields={optionalFirstPartyFields}
        silenceToast={silenceToast}
      />
    </Form>
  );
};

export default NUXForm;
